export const API_URL = process.env.REACT_APP_API_URL;
export const PAYSTACK_SECRET =  process.env.REACT_APP_PAYSTACK_SECRET